/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import {
  DrawRuleBasis,
  DrawRuleContentDto,
  DrawRuleDetailsDto,
  DrawRuleListItemDto,
} from './draw-rule.dto';

export const DrawRuleListItemMapper = entity<DrawRuleListItemDto>({});

export const DrawRuleContentMapper = entity<DrawRuleContentDto>({
  basis: enumeration(DrawRuleBasis),
});
export const DrawRuleSaveMapper = DrawRuleContentMapper;

export const DrawRuleDetailsMapper = entity<DrawRuleDetailsDto>({
  drawRule: DrawRuleContentMapper,
});
